/**
 * Created by danielg on 8/31/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    window.lpTag.AMSStatics = window.lpTag.AMSStatics || {};

    var _ = require('underscore');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpSdeDataHandler = require('web-agent-assets-js/lpSdeDataHandler');
    var MessagingUtils = require('web-agent-utils/MessagingUtils');

    /////////////////////////////////// CONSTANT VARIABLES ///////////////////////////////////
    var USER_PROFILE_ROLES = lpTag.AMSStatics.participant.roles;
    var APPLICATION_TYPE = 'UserProfilesControllerV2';

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////
    var amsCommunicationChannel = webAgentStatics.COMMUNICATION_CHANNELS.AMS;
    var logger = WebAgentLogger.getLogger(APPLICATION_TYPE);
    var enableBlockVisitorName = false;
    var waitingList = {};

    /////////////////////////////////// INITIALIZATION ///////////////////////////////////
    var userProfilesController = BaseController.extend(function lpUserProfilesController(options) {
        lpTag.WebAgent.channel.register(amsCommunicationChannel.name, amsCommunicationChannel.events.onUserInfo, this.onUserInfo.bind(this));
        enableBlockVisitorName = lpTag.WebAgent.logicController.enableBlockVisitorName();

        // TODO: Fix this shit, the test not pass without this allocation.
        logger = this.logger || WebAgentLogger.getLogger(this.applicationType);

        this.model.bind('agent.id', onAgentDataReady, this);
        function onAgentDataReady(){
            _createMyProfileFromACSData(this);
            this.model.unbind('agent.id', onAgentDataReady, this);
        }

    });

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////
    userProfilesController.prototype.applicationType = APPLICATION_TYPE;


    userProfilesController.prototype.i18n = {
        AGENT_DEFAULT_NAME: agentLEManager.translateLE('LEWebAgent.agentDefaultName'),
        PARTICIPANT_DEFAULT_NAME: agentLEManager.translateLE('LEWebAgent.participantDefaultName'),
        BOT_CONTROLLER_DEFAULT_NAME: agentLEManager.translateLE('LEWebAgent.autoMessageBotDefaultName')
    };

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////
    /**
     * Called when we receive the user info from the ams client
     * @param userInfo - The user info
     */
    userProfilesController.prototype.onUserInfo = function (userInfo) {
        logger.debug('user info received: ' + userInfo);
        _handleUserInfo.call(this, userInfo);
    };

    userProfilesController.prototype.setConsumerProfileOnBehalfOfAgent = function (request) {
        if (!request) {
            return;
        }

        var payload = validateRequestData(request);
        payload.error = request.error;
        payload.success = request.success;
        payload.userId = request.userId;
        lpTag.WebAgent.amsConnectionController.amsClient.setConsumerProfileOnBehalfOfAgent(payload);

        function validateRequestData(reqData) {
            var supportedRequest = {};
            var supportedRequestFields = {
                firstName: "firstName",
                lastName: "lastName",
                email: "email",
                phone: "phone",
                avatarUrl: "avatarUrl",
                backgndImgUri: "backgndImgUri",
                description: "description"
            };
            for (var key in reqData) {
                var supportedKey = supportedRequestFields[key];
                if (supportedKey) {
                    supportedRequest[key] = reqData[key];
                }
            }
            return supportedRequest;
        }
    };

    /**
     * get the user profile from the AMS service.
     * @param request
     */
    userProfilesController.prototype.getUserProfile = function (request, force) {
        var self, userId, userProfileModel;
        if (!request) {
            return;
        }

        self = this;
        userId = request.userId || request.consumerId;
        if (userId) {
            // check if the user profile has been fetched and exists in the model
            userProfileModel = this.model.get(lpAMSController.MODEL_PATHS.userProfiles + '.' + userId);
            if (userProfileModel && !force) {
                if (request && request.success) {
                    invokeUserInfoCallback(userProfileModel, request.participantType);
                    request.success(userProfileModel);
                }
            }
            else {
                _addToWaitingList(userId, request.success, request.error);
                // if it's first in the waiting list, run the AMS client call
                if (waitingList && waitingList.hasOwnProperty(userId) && waitingList[userId].length === 1) {
                    lpTag.WebAgent.amsConnectionController.amsClient.getUserProfile({
                        userId: userId,
                        success: onRequestSuccess,
                        error: onRequestError
                    });
                }
            }
        }

        function onRequestError() {
            if (waitingList.hasOwnProperty(userId)) {
                var waitingRequests = waitingList[userId];
                while (waitingRequests.length) {
                    var r = waitingRequests.pop();
                    if (r.error) {
                        r.error.apply(null, arguments);
                    }
                }
                _removeUserIdFormWaitingList(userId);
                logger.error('Get user profile failed for userId: ' + userId);
                logger.graph({name: 'getUserProfileError'});
            }
        }

        function onRequestSuccess(userProfile) {

            invokeUserInfoCallback(userProfile, request.participantType, true);

            if (waitingList.hasOwnProperty(userId)) {
                var waitingRequests = waitingList[userId];
                while (waitingRequests.length) {
                    var r = waitingRequests.pop();
                    if (r.success) {
                        r.success.call(null, userProfile);
                    }
                }
                _removeUserIdFormWaitingList(userId);
                logger.info('Get user profile succeeded for userId: ' + userId);
            }
        }

        /**
         * invokes the user-info callback to register changes to model, if the participant type was changed
         *
         * @param userProfile the user profile to register
         * @param participantType override the current participant type
         * @param force invoke the user-info callback even if there was no update to the participant type
         */
        function invokeUserInfoCallback(userProfile, participantType, force) {
            var updated = false;
            // overriding the role with the request participant type
            if (participantType && userProfile.role !== participantType) {
                userProfile.role = participantType;
                updated = true;
            }
            if (updated || force) {
                self.onUserInfo(userProfile);
            }
        }

    };

    /**
     * fetches user profiles asynchronously, and waits for all requests to resolve before calling the done callback.
     *
     * @param request
     * @param request.users can be an array of user ids, e.g. ['1234-1234-1234-1234', '5678-5678-5678-5678'],
     *      or a map of user ids grouped by participant type, e.g.: { ASSIGNED_AGENT: ['1234-1234-1234-1234', '5678-5678-5678-5678'] }
     * @param request.done a callback function, invoked when all profiles are fetched (and are ready in the model).
     */
    userProfilesController.prototype.getUserProfiles = function (request) {
        var profilesCount, profilesQueue, i, profile, users, participantType, done;

        request = request || {};

        profilesCount = 0;
        profilesQueue = [];

        done = request.done;
        users = request.users;

        if (users) { // guard from null value (won't pass 'object' typeof check)
            if (users.constructor === Array) { // it's an array of user ids, just push it to the queue
                queueUserProfiles(users);
            } else if (typeof users === 'object') { // it's a map of user ids, grouped by participant type
                for (participantType in users) {
                    if (users.hasOwnProperty(participantType)) {
                        queueUserProfiles(users[participantType], participantType);
                    }
                }
            }
        }

        if (profilesQueue.length) {
            profilesCount = profilesQueue.length;
            while (profilesQueue.length) {
                profile = profilesQueue.pop();
                this.getUserProfile({
                    userId: profile.userId,
                    participantType: profile.participantType,
                    success: onProfileResolveCompleted,
                    error: onProfileResolveCompleted
                });
            }
        } else {
            done();
        }

        function queueUserProfiles(userIds, userParticipantType) {
            for (i = 0; i < userIds.length; i++) {
                profilesQueue.push({
                    participantType: userParticipantType,
                    userId: userIds[i]
                });
            }
        }

        function onProfileResolveCompleted() {
            if (--profilesCount === 0) {
                done();
            }
        }
    };

    /**
     * Gets the logged in agent's profile from the AMS client
     */
    userProfilesController.prototype.getMyProfile = function () {
        var self = this;
        lpTag.WebAgent.amsConnectionController.amsClient.getMyUserProfile({
            success: function (data) {
                if (data && data.userId) {
                    _updateProfileModel(self,data, true);
                } else {
                    logger.error('Requested my profile but did not receive user ID', 'getMyProfile');
                    logger.graph({name: 'getMyProfileDataError'});
                }
            },
            error: function (errorData) {
                logger.error('Error getting my profile: ' + JSON.stringify(errorData), 'getMyProfile');
                logger.graph({name: 'getMyProfileError'});
            },
            context: this
        });
    };

    userProfilesController.prototype.getUserProfileById = function (userId) {
        return this.model.get("userProfiles." + userId);
    };


    /**
     * Adds AMS-client callbacks to the settings object
     * @param settings The object we add the callbacks to
     */
    // userProfilesController.prototype.addClientCallbacks = function (settings) {
    //     settings.onUserInfo = {func: this.onUserInfo, context: this};
    // };

    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////

    function _handleUserInfo(userInfo) {
        if (userInfo) {
            var userPath = lpAMSController.MODEL_PATHS.userProfiles + '.' + userInfo.userId;
            if(enableBlockVisitorName){
                userInfo.description = '';
            }
            if (!userInfo.role) {
                var currentUserData = this.model.get(userPath);
                if (currentUserData && currentUserData.role) {
                    userInfo.role = currentUserData.role;
                }
            }
            userInfo.fullName = MessagingUtils.getParticipantFullName(userInfo.firstName, userInfo.lastName, userInfo.role, enableBlockVisitorName);
            userInfo.imgUrl = userInfo.avatarUrl = userInfo.imgUrl || userInfo.avatarUrl || '';
            if (userInfo.claims) {
                if (userInfo.acr === 'loa1') { // authenticated
                    _.assign(userInfo, handleAuthenticatedData(userInfo.claims));
                }
                userInfo.claimsAndAuthType = { claims: userInfo.claims, acr: userInfo.acr };
            } else if (userInfo.authenticatedData) { // will be deprecated
                _.assign(userInfo, handleAuthenticatedData(userInfo.authenticatedData));
            }
            this.model.set(userPath, userInfo);
        }
    }

    function handleAuthenticatedData(authenticatedData) {
        var data = {};
        var sdes = authenticatedData && authenticatedData.lp_sdes ? authenticatedData.lp_sdes : [];

        for (var i = 0; i < sdes.length; i++) {
            switch (sdes[i].type) {
                case "ctmrinfo":
                    data.customerInfo = sdes[i].info;
                    break;
                case "personal":
                    data.personalInfo = sdes[i].personal;
                    break;
            }
        }
        return parseSdeForAuth(data);
    }

    function parseSdeForAuth(data) {
        return {
            participant: {
                customerInfo: lpSdeDataHandler.getProcessedCustomerInfoEvent(data),
                personalInfo: lpSdeDataHandler.getProcessedPersonalInfoEvent(data),
                isAuthenticated: true
            }
        };
    }

    /**
     * Sets the given user ID to the model
     * @param userId The user ID to set to the model
     * @private
     */
    function _setUserIdToModel(userId) {
        logger.debug('Received user ID: ' + userId, 'onUserId');
        this.model.modify(lpAMSController.MODEL_PATHS.userId, userId);
    }

    function _removeUserIdFormWaitingList(userId) {
        if (waitingList.hasOwnProperty(userId)) {
            delete waitingList.userId;
        }
    }

    function _addToWaitingList(userId, successCB, errorCB) {
        if (!waitingList.hasOwnProperty(userId)) {
            waitingList[userId] = [];
        }

        waitingList[userId].push({
            success: successCB,
            error: errorCB
        });
    }


    /**
     * updating the profile in the model.
     * @param context - class context.
     * @param data - the profile data
     * @param overrideProfile - override current profile data flag.
     * @private
     */
    function _updateProfileModel(context, data, overrideProfile) {
        _setUserIdToModel.call(context, data.userId);
        if (!data.role || overrideProfile) {
            data.role = USER_PROFILE_ROLES.ASSIGNED_AGENT;
            _handleUserInfo.call(context, data);
        }
    }

    /**
     * Creating a basic profile for the current agent and send it to the model.
     * @param context
     * @private
     */
    function _createMyProfileFromACSData (context) {
        logger.info('Creating User Profile From AC Service data.');

        var userId = context.model.get('agent.id');
        var displayName = context.model.get('agent.displayName');
        var accountId = context.model.get('account');
        var messagingUserId = accountId + '.' + userId;

        // Creating the basic Profile data for the Profile Object.
        var myProfile = {
            avatarUrl: '',
            firstName: displayName,
            lastName: '',
            userId: messagingUserId
        };

        _updateProfileModel(context, myProfile);

        logger.info('User Profile From AC Service created.');
    }


    return userProfilesController;

});
